// @flow
/* eslint-disable react/no-array-index-key */

// https://github.com/moroshko/react-autosuggest

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import {withStyles} from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

function renderInput(inputProps) {
  const {
    classes,
    home,
    value,
    ref,
    label,
    endAdornment,
    onBlur,
    onFocus,
    onMouseOver,
    onMouseOut,
    ...other
  } = inputProps;
  return (
    <TextField
      autoFocus={home}
      className={classes.textField}
      value={value}
      label={label}
      inputRef={ref}
      onBlur={onBlur}
      onFocus={onFocus}
      onMouseOut={onMouseOut}
      onMouseOver={onMouseOver}
      InputProps={{
        classes: {
          input: classes.input
        },
        endAdornment,
        ...other
      }}
    />
  );
}

function renderSuggestion(suggestion, {query, isHighlighted}) {
  const matches = match(suggestion.name, query);
  const parts = parse(suggestion.name, matches);

  return (
    <MenuItem
      className={`suggestion_${suggestion.type}`}
      selected={isHighlighted}
      component="div"
    >
      <div data-type={suggestion.icon || suggestion.type} style={{display: 'flex'}}>
        {
          parts.map((part, index) => {
            const text = part.text.replace(/ /g, '\u00a0');
            if (part.highlight) {
              return <span key={index}>{text}</span>;
            }
            return <strong key={index}>{text}</strong>;
          })
        }
      </div>
    </MenuItem>
  );
}

function getSuggestionValue(suggestion) {
  return suggestion.name;
}

const styleSheet = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0,
    zIndex: 2
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  textField: {
    width: '100%'
  }
});

class AutoCompleteInput extends Component {

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    startFetchLength: PropTypes.number,
    onFetchRequested: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    endAdornment: PropTypes.element
  };

  static defaultProps = {
    startFetchLength: 1,
    placeholder: '',
    label: '',
    endAdornment: null
  };

  state = {
    value: '',
    suggestions: []
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.list) {
      this.setState({suggestions: nextProps.list});
    }
  }

  handleSuggestions = ({value}) => {
    this.setState({suggestions: []}, () => {
      this.handleSuggestionsFetchRequested(value);
    });
  }

  handleSuggestionsFetchRequested(value) {
    const {startFetchLength} = this;
    const inputLength = value.trim().length;

    if (inputLength < startFetchLength) {
      return;
    }

    this.props.onFetchRequested(value);
  }

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  }

  handleChange = (event, {newValue}) => {
    this.setState({
      value: newValue
    });
  }

  onMouseOver = event => this.props.onMouseOver && this.props.onMouseOver(event);
  onMouseOut = event => this.props.onMouseOut && this.props.onMouseOut(event);
  onBlur = event => this.props.onBlur && this.props.onBlur(event);
  onFocus = event => this.props.onFocus && this.props.onFocus(event);

  handleSelected = (event, {suggestion, suggestionValue, suggestionIndex}) => {
    this.props.onSelect(event, {suggestion, suggestionValue, suggestionIndex});
    if (!this.props.keepValueSelected) {
      this.setState({value: '', suggestions: []});
    }
  }

  renderSuggestionsContainer = options => {
    const {containerProps, children} = options;

    return (
      <Paper {...containerProps} square>
        {children}
        {this.props.isLoading && <LinearProgress />}
      </Paper>
    );
  }

  render() {
    const {classes} = this.props;
    let {value, onChange} = this.props;
    if (!value) {
      ({value} = this.state);
    }

    if (!onChange) {
      onChange = this.handleChange;
    }

    return (
      <Autosuggest
        theme={{
          container: classes.container,
          suggestionsContainerOpen: classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        highlightFirstSuggestion
        renderInputComponent={renderInput}
        suggestions={this.state.suggestions}
        onSuggestionsFetchRequested={this.handleSuggestions}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        onSuggestionSelected={this.handleSelected}
        focusInputOnSuggestionClick={false}
        inputProps={{
          autoFocus: false,
          classes,
          label: this.props.label,
          placeholder: this.props.placeholder,
          endAdornment: this.props.endAdornment,
          id: this.props.id,
          value,
          onChange,
          onKeyDown: this.onKeyDown,
          onBlur: this.onBlur,
          onFocus: this.onFocus,
          onMouseOver: this.onMouseOver,
          onMouseOut: this.onMouseOut
        }}
      />
    );
  }
}

export default withStyles(styleSheet, {name: 'AutoCompleteInput'})(AutoCompleteInput);
